import StaticContentsContainer from '../components/StaticContentsContainer';
import specimensRobot from '../../../../assets/images/test/specimens-robot.png';

function SpecimensDeliveryRobotDescription() {
    const container = StaticContentsContainer();
    container.classList.add('robot-description');
    container.innerHTML = `
    <h2>검체 배송 로봇</h2>
    <div class="robot-img-container">
        <div class="robot-img">
            <img src="${specimensRobot}" alt="specimens delivery robot">
        </div>
    </div>
    <ul class="robot-description-list">
        <li class="robot-description-item">검체 수거 시 보내고 받는 직원 간 이중 확인 작업 프로세스 변경이 필요할 수 있어 관련 직원의 동의가 필요합니다.</li>
        <li class="robot-description-item">유해물질 관리 관련 기관별 인증 규정을 사전에 확인해야 합니다.</li>
        <li class="robot-description-item">로봇 배송 중 에러로 검체가 오랜시간 방치될 수 있으므로 에러 확인 및 대응 방안을 사전에 준비해야 합니다.</li>              
    </ul>
    `;
    return container;
}

export default SpecimensDeliveryRobotDescription;
